import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-denied-register',
  templateUrl: './denied-register.component.html',
  styleUrls: ['./denied-register.component.css']
})
export class DeniedRegisterComponent implements OnInit {

  constructor(
    private cookie:CookieService,
  ) { }
  
  ngOnInit() {
    this.cookie.deleteAll();
    localStorage.clear();
  }

}
